function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e6e6e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M5,26H6v3a1,1,0,0,0,1.406.914L16.212,26H23a3,3,0,0,0,3-3V15a1,1,0,0,0-2,0v8a1,1,0,0,1-1,1H16l-.008,0a1.007,1.007,0,0,0-.192.038,1.017,1.017,0,0,0-.2.044l-.008,0L8,27.461V25a1,1,0,0,0-1-1H5a1,1,0,0,1-1-1V9A1,1,0,0,1,5,8H16.92a1,1,0,0,0,0-2H5A3,3,0,0,0,2,9V23a3,3,0,0,0,3,3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M25,12a5,5,0,1,0-5-5,5,5,0,0,0,5,5Zm0-8a3,3,0,1,1-3,3A3,3,0,0,1,25,4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M7,12h5a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M7,16h9a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Z"
}));

function SvgGiftCardsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardsIcon);
export default __webpack_public_path__ + "static/media/gift-cards-icon.4438cd28.svg";
export { ForwardRef as ReactComponent };